[
  {
    "id": 1,
    "group": "SUP",
    "start": "2025-02-15",
    "end": "2025-04-08"
  },
  {
    "id": 2,
    "group": "SUP",
    "start": "2025-02-15",
    "end": "2025-04-30"
  },
  {
    "id": 3,
    "group": "AMDT",
    "start": "2025-03-15",
    "end": "2025-04-02"
  },
  {
    "id": 4,
    "group": "AMDT",
    "start": "2025-06-20",
    "end": "2025-06-25"
  },
  {
    "id": 5,
    "group": "AMDT",
    "start": "2025-01-10",
    "end": "2025-02-05"
  },
  {
    "id": 6,
    "group": "AMDT",
    "start": "2025-02-05",
    "end": "2025-02-28"
  },
  {
    "id": 7,
    "group": "AMDT",
    "start": "2025-02-28",
    "end": "2025-03-05"
  },
  {
    "id": 8,
    "group": "AMDT",
    "start": "2025-03-05",
    "end": "2025-03-15"
  },
  {
    "id": 9,
    "group": "AMDT",
    "start": "2025-04-02",
    "end": "2025-04-25"
  },
  {
    "id": 10,
    "group": "AMDT",
    "start": "2025-04-25",
    "end": "2025-05-10"
  },
  {
    "id": 11,
    "group": "AMDT",
    "start": "2025-05-10",
    "end": "2025-05-30"
  },
  {
    "id": 12,
    "group": "AMDT",
    "start": "2025-05-30",
    "end": "2025-06-10"
  },
  {
    "id": 13,
    "group": "AMDT",
    "start": "2025-06-10",
    "end": "2025-06-20"
  },
  {
    "id": 14,
    "group": "AMDT",
    "start": "2025-06-25",
    "end": "2025-07-15"
  },
  {
    "id": 15,
    "group": "AMDT",
    "start": "2025-07-15",
    "end": "2025-07-30"
  },
  {
    "id": 16,
    "group": "AMDT",
    "start": "2025-07-30",
    "end": "2025-08-12"
  },
  {
    "id": 17,
    "group": "AMDT",
    "start": "2025-08-12",
    "end": "2025-08-28"
  },
  {
    "id": 18,
    "group": "AMDT",
    "start": "2025-08-28",
    "end": "2025-09-10"
  },
  {
    "id": 19,
    "group": "AMDT",
    "start": "2025-09-10",
    "end": "2025-09-22"
  },
  {
    "id": 20,
    "group": "AMDT",
    "start": "2025-09-22",
    "end": "2025-10-05"
  },
  {
    "id": 21,
    "group": "AMDT",
    "start": "2025-10-05",
    "end": "2025-10-20"
  },
  {
    "id": 22,
    "group": "AMDT",
    "start": "2025-10-20",
    "end": "2025-11-02"
  },
  {
    "id": 23,
    "group": "AMDT",
    "start": "2025-11-02",
    "end": "2025-11-18"
  },
  {
    "id": 24,
    "group": "AMDT",
    "start": "2025-11-18",
    "end": "2025-12-01"
  },
  {
    "id": 25,
    "group": "AMDT",
    "start": "2025-12-01",
    "end": "2025-12-12"
  },
  {
    "id": 26,
    "group": "AMDT",
    "start": "2025-12-12",
    "end": "2025-12-22"
  },
  {
    "id": 27,
    "group": "AMDT",
    "start": "2025-12-22",
    "end": "2025-12-27"
  },
  {
    "id": 28,
    "group": "AMDT",
    "start": "2025-12-27",
    "end": "2025-12-31"
  },
  {
    "id": 29,
    "group": "AMDT",
    "start": "2025-12-31",
    "end": null
  },
  {
    "id": 30,
    "group": "SUP",
    "start": "2025-06-10",
    "end": "2025-06-15"
  },
  {
    "id": 31,
    "group": "SUP",
    "start": "2025-07-01",
    "end": "2025-07-10"
  },
  {
    "id": 32,
    "group": "SUP",
    "start": "2025-07-15",
    "end": "2025-07-16"
  },
  {
    "id": 33,
    "group": "SUP",
    "start": "2025-08-01",
    "end": "2025-10-30"
  },
  {
    "id": 34,
    "group": "SUP",
    "start": "2025-08-05",
    "end": "2025-09-15"
  },
  {
    "id": 35,
    "group": "SUP",
    "start": "2025-09-01",
    "end": "2025-09-20"
  },
  {
    "id": 36,
    "group": "SUP",
    "start": "2025-09-10",
    "end": "2025-11-10"
  },
  {
    "id": 37,
    "group": "SUP",
    "start": "2025-10-01",
    "end": "2025-10-03"
  },
  {
    "id": 38,
    "group": "SUP",
    "start": "2025-10-15",
    "end": "2025-11-15"
  },
  {
    "id": 39,
    "group": "SUP",
    "start": "2025-11-01",
    "end": "2025-11-30"
  },
  {
    "id": 40,
    "group": "SUP",
    "start": "2025-11-10",
    "end": "2025-12-01"
  },
  {
    "id": 41,
    "group": "SUP",
    "start": "2025-12-05",
    "end": "2025-12-15"
  },
  {
    "id": 42,
    "group": "SUP",
    "start": "2025-12-20",
    "end": "2025-12-25"
  },
  {
    "id": 43,
    "group": "SUP",
    "start": "2025-12-28",
    "end": "2026-01-10"
  },
  {
    "id": 44,
    "group": "SUP",
    "start": "2025-12-28",
    "end": "2026-01-20"
  },
  {
    "id": 45,
    "group": "SUP",
    "start": "2026-01-15",
    "end": "2026-02-15"
  },
  {
    "id": 46,
    "group": "SUP",
    "start": "2026-02-01",
    "end": "2026-03-10"
  },
  {
    "id": 47,
    "group": "SUP",
    "start": "2026-02-15",
    "end": "2026-02-16"
  },
  {
    "id": 48,
    "group": "SUP",
    "start": "2026-03-01",
    "end": "2026-03-20"
  },
  {
    "id": 49,
    "group": "SUP",
    "start": "2026-03-10",
    "end": "2026-04-01"
  },
  {
    "id": 50,
    "group": "SUP",
    "start": "2026-04-05",
    "end": "2026-04-15"
  },
  {
    "id": 51,
    "group": "SUP",
    "start": "2026-04-20",
    "end": "2026-05-20"
  },
  {
    "id": 52,
    "group": "SUP",
    "start": "2026-05-10",
    "end": "2026-06-15"
  },
  {
    "id": 53,
    "group": "SUP",
    "start": "2026-06-01",
    "end": "2026-06-05"
  },
  {
    "id": 54,
    "group": "SUP",
    "start": "2025-03-15",
    "end": "2025-05-05"
  },
  {
    "id": 55,
    "group": "SUP",
    "start": "2025-03-02",
    "end": "2025-05-05"
  },
  {
    "id": 56,
    "group": "SUP",
    "start": "2025-03-08",
    "end": "2025-05-16"
  }
]
